import React, { Component } from 'react';
import {NavLink, Link} from 'react-router-dom';


class Sidebar extends Component {

   constructor(props) {
    super(props);

     this.state={

     }
  }
  render() {
    const _this=this;

    return (

        <div className="sidebar" data-color="azure" data-background-color="white" data-image="/img/sidebar-1.jpg">

      <div className="logo">
        <Link to="#" className="simple-text logo-normal text-center">
          ETTI - PORTAL ADMIN
        </Link>
      </div>
      <div className="sidebar-wrapper">
        <ul className="nav">
          <li className="nav-item">
            <NavLink className="nav-link" to="/admin_ui/post_new">
              <i className="material-icons">queue</i>
              <p>Post New</p>
            </NavLink>
          </li>
          <li className="nav-item ">
            <NavLink className="nav-link" to="/admin_ui/notices">
              <i className="material-icons">dashboard</i>
              <p>View Announcements</p>
            </NavLink>
          </li>
          
        </ul>
      </div>
    <div className="sidebar-background"></div></div>





    );
  }




}

export default Sidebar;
